// extracted by mini-css-extract-plugin
export default {"checkbox":"Checkbox_checkbox__RzrJS","commitText":"Checkbox_commitText__-mGn4","checkbox-label":"Checkbox_checkbox-label__lwdCP"};